export default __webpack_public_path__ + "static/weaving-823705324585e6d3730e5ee90a52eb44.png";